import { LOCALES, type Locale } from "../domain/types";

const LOCALE_LABELS: Record<Locale, string> = { en: "EN", tr: "TR" };
const LOCALE_NAMES: Record<Locale, string> = {
  en: "English",
  tr: "Türkçe",
};

interface Props {
  locale: Locale;
  onChange: (locale: Locale) => void;
}

export function LocaleSwitcher({ locale, onChange }: Props) {
  return (
    <div className="locale-switcher" role="group" aria-label="Language">
      {LOCALES.map((option) => (
        <button
          key={option}
          type="button"
          className="locale-switcher__option"
          aria-pressed={option === locale}
          aria-label={`${LOCALE_LABELS[option]} – ${LOCALE_NAMES[option]}`}
          onClick={() => {
            if (option !== locale) onChange(option);
          }}
        >
          {LOCALE_LABELS[option]}
        </button>
      ))}
    </div>
  );
}
